export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "avalon2-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "avalon2-themeWrapLive" */'./LiveThemeImporter'),
  },
};
